import {MeshCellNoteId} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshCellNote';
import {MeshCellSettingsId} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshCellSettings';
import {MeshLocationKey} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshLocation';
import {SheetId, SlotId} from '@mintdata/mint-kit/api/models/Identifiers';
import {observable} from 'mobx';

export type SheetSettingsId = string;

export abstract class AnySheetSettings
{
    @observable
    public id:SheetSettingsId;

    @observable
    public sheetId:SheetId;

    @observable
    public slotId:SlotId;

    @observable
    public cellSettings:Map<MeshLocationKey, MeshCellSettingsId>;

    @observable
    public cellNotes:Map<MeshLocationKey, MeshCellNoteId>;

    @observable
    public cellFormats:Map<MeshLocationKey, MeshCellSettingsId>;
}
